export const LANG_ES_NAME = "es";

export const LANG_ES_TRANS = {
	"download.button" : "Descargue",
	// tslint:disable-next-line:max-line-length
	"download.configuration.message" : "Después de que su dispositivo virtual se ha instalado correctamente, la instalación continuará en la consola de máquina virtual",
	"download.info.block.1" : "Haga clic en",
	"download.info.block.2" : "aquí",
	"download.info.block.3" : "Para ver la documentación de instalación",
	"download.info.block.4" : "Para obtener ayuda, póngase en contacto con soporte:",
	"download.info.title" : "Descargue SafeConnect",
	"download.media.version" : "Versión",
	"download.media.size" : "Tamaño",
	"download.media.unselected" : "Por favor elige la media para su instalación.",
	"download.statusMessage.404" : "Había un error mientras su descarga. Por favor llame a Soporte para ayudarle.",
	"download.statusMessage.200" : "Su descarga ha empenzado.",
	"footer.rights" : "TODOS LOS DERECHOS RESERVADOS",
	"header.sub.title" : "Portal de a la nube"
}
